import request from '@/utils/request'
import { encrypt } from '@/utils/jsencrypt'
// 登录方法
export function login(username, password, code, uuid) {
  password = encrypt(password);
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/auth/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 企业微信登录方法-中铁e通
export function loginByQx(username) {
  const data = {
    username
  };
  return request({
    url: '/auth/etLogin',
    method: 'post',
    data: data
  });
}


// 注册方法
export function register(data) {
  return request({
    url: '/auth/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'delete'
  })
}
// 刷新登录信息
export function reLogin(data) {
  return request({
    url: '/auth/reLogin',
    method: 'post',
    data: data
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/system/user/getInfo',
    method: 'get'
  })
}

// 获取用户详细信息
export function getWebInfo() {
  return request({
    url: '/system/user/getWebInfo',
    method: 'get'
  })
}

// 数智门户登录
export function portalLogin(code) {
  const data = {
    code
  };
  return request({
    url: '/auth/portalLogin',
    method: 'post',
    data: data
  });
}

// 获取短信验证码
export function getSmsCode(phone) {
  return request({
    // url: '/auth/captcha/'+ phone,
    url: `/auth/captcha?phone=${phone}`,
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 600000
  })
}

// 招聘网站登录
export function webLogin(username, password, code) {
  password = encrypt(password);
  const data = {
    username,
    password,
    code
  };
  return request({
    url: '/auth/webLogin',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 招聘网站验证码登录
export function webLoginCode(username, code) {
  const data = {
    username,
    code
  };
  return request({
    url: '/auth/webLoginCode',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}
